import { ReactElement } from "react"

import CreateEVACDeviceForm from "../../../../components/devices/lct/evac/createEVACDeviceForm"
import PublishEVACDeviceProvider from "../../../../components/devices/lct/evac/providers/publishEVACDeviceProvider"

const PublishEVACDevice = (): ReactElement => (
    <PublishEVACDeviceProvider>
        <CreateEVACDeviceForm />
    </PublishEVACDeviceProvider>
)

export default PublishEVACDevice
